import get from 'lodash/get';
import concat from 'lodash/concat';

/**
 * Factory method for transforming a response from the Retail API into a format that
 * the general Retail Redux architecture supports (JSON API).
 *
 * @param {string} path The path to where in the API response the data resides
 *
 * @returns {function}  A function that takes the result of an API response as
 *                      a parameter and transforms the result into the expected
 *                      format.
 */
export const createRetailTransformer = path => result => ({
  data: get(result, path),
});

/**
 * Factory method for transforming a listing response from the Retail API into a format that
 * the general Retail Redux architecture supports (JSON API).
 *
 * @param {string} path The path to where in the API response the data resides
 *
 * @returns {function}  A function that takes the result of an API response as
 *                      a parameter and transforms the result into the expected
 *                      format.
 */
export const createRetailListTransfomer = path => result => ({
  data: concat([], get(result, path, [])),
});

/**
 * Factory method for generating transformers for a particular retail API schema.
 *
 * @param {string} path The path to where in the API response the data resides
 *
 * @returns {object}
 * @returns {object.transformer}  A function that transforms a single API entity
 * @returns {object.listTransformer}  A function that transforms a list of API entities
 */
export const createRetailTransformers = path => ({
  transformer: createRetailTransformer(path),
  listTransformer: createRetailListTransfomer(path),
});
